import useBcFolderStore from '@/frontapp/store/bcFolder'

export default {
  methods: {
    addFolder() {
      const bcFolderStore = useBcFolderStore()
      this.$store.commit('nette/updateControl', {
        controlName: 'editForm',
        data: true,
        key: 'showModal',
      })

      this.$formValues['frm-editForm-editForm-name'] = ''
      this.$formValues['frm-editForm-editForm-rank'] = bcFolderStore.listChildren[bcFolderStore.current.id] ? bcFolderStore.listChildren[bcFolderStore.current.id].length : 0
      this.$formValues['frm-editForm-editForm-id:change'] = ''
      this.$formValues['frm-editForm-editForm-element_type:change'] = 'folder'
      this.$formValues['frm-editForm-editForm-bc_folder_id'] = bcFolderStore.current.id
      this.$formValues['frm-editForm-editForm-link'] = ''
      this.$formValues['frm-editForm-editForm-header__file_id'] = null
      this.$formValues['frm-editForm-editForm-image__file_id'] = null
      this.$formValues['frm-editForm-editForm-icon_text'] = null
      this.$formValues['frm-editForm-editForm-icon_bg_color'] = null
      this.$formValues['frm-editForm-editForm-icon_text_color'] = '#FFFFFF'

      this.$store.commit('nette/updateControl', {
        controlName: 'frm-editForm-editForm-header__file_id',
        data: null,
        key: 'file',
      })

      this.$store.commit('nette/updateControl', {
        controlName: 'frm-editForm-editForm-image__file_id',
        data: null,
        key: 'file',
      })

      setTimeout(() => {
        window.document.getElementById('frm-editForm-editForm-name').focus()
      }, 100)
    }
  }
}